module.exports = __webpack_public_path__ + "linea-arrows-10.839102e05032bae37b07.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/linea/arrows/fonts/linea-arrows-10.svg
// module id = ../../../../../src/assets/fonts/linea/arrows/fonts/linea-arrows-10.svg
// module chunks = styles